export default "/images/logo-10.png?b676c7ad8d8c217d5ac3349bfe75ebc5";